import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://myfvkydvwifzeyqthkrw.supabase.co'
const SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im15ZnZreWR2d2lmemV5cXRoa3J3Iiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTc3ODc4MzQ0OSwiZXhwIjoyMDk0MzU5NDQ5fQ.QO0016Rx6zvnZw0D_rG8jDbBneiIPbC4_n8KDQLpFnQ'

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY)

// Helper: calculate days between two dates
export const daysBetween = (date1, date2 = new Date()) => {
  if (!date1) return null
  const d1 = new Date(date1)
  const d2 = new Date(date2)
  return Math.round((d1 - d2) / (1000 * 60 * 60 * 24))
}

// Helper: get meeting status
export const getMeetingStatus = (daysToMeeting) => {
  if (daysToMeeting === null) return { label: 'No meeting set', color: 'gray' }
  if (daysToMeeting < 0) return { label: `${Math.abs(daysToMeeting)}d overdue`, color: 'red' }
  if (daysToMeeting <= 5) return { label: `${daysToMeeting}d — urgent`, color: 'red' }
  if (daysToMeeting <= 15) return { label: `${daysToMeeting}d`, color: 'yellow' }
  return { label: `${daysToMeeting}d`, color: 'green' }
}

// Helper: get initials
export const getInitials = (name) => {
  if (!name) return '??'
  return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)
}
